// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import Errors, { NetworkingError } from 'lib/errors';

const apiFetch = (url: string, options: *) =>
  fetch(getEndpointUrl(url), options)
    .then(checkResponse)
    .catch((err: Error) =>
      Promise.reject(Errors.isHttpError(err) ? err : new NetworkingError())
    );

export default apiFetch;



// WEBPACK FOOTER //
// ./src/api/fetch.js